import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
import { NewWatchNowOfferFragmentDoc } from './WatchNowOffer.fragment';
export type NewTitleGraphqlFragment = {
	__typename?: 'NewTitlesEdge';
	cursor: string;
	watchNowOffer?: {
		__typename: 'Offer';
		lastChangeRetailPrice?: string | null;
		lastChangePercent?: number | null;
		id: string;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		lastChangeRetailPriceValue?: number | null;
		currency?: string | null;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		availableTo?: any | null;
		dateCreated?: any | null;
		newElementCount?: number | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			icon: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			iconWide: string;
			hasRectangularIcon: boolean;
		};
	} | null;
	node:
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				content: {
					__typename?: 'MovieContent';
					title: string;
					shortDescription?: string | null;
					fullPath: string;
					posterUrl?: string | null;
					runtime?: number | null;
					isReleased: boolean;
					scoring: {
						__typename?: 'Scoring';
						imdbVotes?: number | null;
						imdbScore?: number | null;
						tmdbPopularity?: number | null;
						tmdbScore?: number | null;
						tomatoMeter?: number | null;
						certifiedFresh?: boolean | null;
					};
					genres: Array<{ __typename?: 'Genre'; translation: string }>;
					upcomingReleases?: Array<{
						__typename?: 'UpcomingRelease';
						releaseDate?: any | null;
						releaseCountDown?: number | null;
						package?: { __typename?: 'Package'; id: string; shortName: string } | null;
					}>;
				};
				availableTo?: Array<{
					__typename?: 'AvailableTo';
					availableCountDown: number;
					availableToDate: any;
					package: { __typename?: 'Package'; id: string; shortName: string };
				}>;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				show: {
					__typename: 'Show';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					content: {
						__typename?: 'ShowContent';
						title: string;
						shortDescription?: string | null;
						fullPath: string;
						posterUrl?: string | null;
						runtime?: number | null;
						scoring: {
							__typename?: 'Scoring';
							imdbVotes?: number | null;
							imdbScore?: number | null;
							tmdbPopularity?: number | null;
							tmdbScore?: number | null;
						};
						genres: Array<{ __typename?: 'Genre'; translation: string }>;
					};
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					seenState: { __typename?: 'ShowSeenState'; progress: number };
				};
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					shortDescription?: string | null;
					fullPath: string;
					posterUrl?: string | null;
					runtime?: number | null;
					isReleased: boolean;
					scoring: {
						__typename?: 'Scoring';
						imdbVotes?: number | null;
						imdbScore?: number | null;
						tmdbPopularity?: number | null;
						tmdbScore?: number | null;
						tomatoMeter?: number | null;
						certifiedFresh?: boolean | null;
					};
					genres: Array<{ __typename?: 'Genre'; translation: string }>;
					upcomingReleases?: Array<{
						__typename?: 'UpcomingRelease';
						releaseDate?: any | null;
						releaseCountDown?: number | null;
						package?: { __typename?: 'Package'; id: string; shortName: string } | null;
					}>;
				};
				availableTo?: Array<{
					__typename?: 'AvailableTo';
					availableCountDown: number;
					availableToDate: any;
					package: { __typename?: 'Package'; id: string; shortName: string };
				}>;
		  };
};

export const NewTitleGraphqlFragmentDoc = gql`
	fragment NewTitleGraphql on NewTitlesEdge {
		cursor
		watchNowOffer: newOffer(platform: $platform) {
			...NewWatchNowOffer
		}
		node {
			__typename
			... on MovieOrSeason {
				id
				objectId
				objectType
				content(country: $country, language: $language) {
					title
					shortDescription
					fullPath
					scoring {
						imdbVotes
						imdbScore
						tmdbPopularity
						tmdbScore
						tomatoMeter
						certifiedFresh
					}
					posterUrl(profile: $profile, format: $format)
					runtime
					genres {
						translation(language: $language)
					}
					... on SeasonContent {
						seasonNumber
					}
					upcomingReleases @include(if: $showDateBadge) {
						releaseDate
						package {
							id
							shortName
						}
						releaseCountDown(country: $country)
					}
					isReleased
				}
				availableTo(country: $country, platform: $platform, packages: $availableToPackages)
					@include(if: $showDateBadge) {
					availableCountDown(country: $country)
					package {
						id
						shortName
					}
					availableToDate
				}
				... on Movie {
					likelistEntry {
						createdAt
					}
					dislikelistEntry {
						createdAt
					}
					seenlistEntry {
						createdAt
					}
					watchlistEntryV2 {
						createdAt
					}
				}
				... on Season {
					likelistEntry {
						createdAt
					}
					dislikelistEntry {
						createdAt
					}
					show {
						__typename
						id
						objectId
						objectType
						content(country: $country, language: $language) {
							title
							shortDescription
							fullPath
							scoring {
								imdbVotes
								imdbScore
								tmdbPopularity
								tmdbScore
							}
							posterUrl(profile: $profile, format: $format)
							runtime
							genres {
								translation(language: $language)
							}
						}
						likelistEntry {
							createdAt
						}
						dislikelistEntry {
							createdAt
						}
						watchlistEntryV2 {
							createdAt
						}
						seenState(country: $country) {
							progress
						}
					}
				}
			}
		}
	}
	${NewWatchNowOfferFragmentDoc}
`;
